const routes = [
    {
        path: '/company/profile',
        name: 'CompanyProfile',
        component: () => import('../../views/company/profile/CompanyProfile.vue')
    },
    {
        path: '/company/profile/update',
        name: 'CompanyProfileUpdate',
        component: () => import('../../views/company/profile/UpdateCompanyProfile.vue')
    },
    {
        path: '/buyer/profile',
        name: 'CompanyBuyerProfile',
        component: () => import('../../views/company/profile/BuyerProfile.vue')
    },
]

export default routes;